import * as yup from 'yup';

export const FIELD_ID = 'application';
export const FIELD_REASON = 'reason';

export const AppealsDeclineValidationForm = yup.object().shape({
  // [FIELD_ID]: yup.string().required('error.required').trim(),
  [FIELD_REASON]: yup.string().required('error.required').trim(),
});
